var H = Object.defineProperty;
var O = (n, A, t) => A in n ? H(n, A, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[A] = t;
var C = (n, A, t) => O(n, typeof A != "symbol" ? A + "" : A, t);
import { M as w } from "../NaturalCompare-BhqAyIXe.js";
import { B as $, H as AA, N as tA, S as eA, U as nA } from "../NaturalCompare-BhqAyIXe.js";
import { C as iA, I as sA, R as rA, a as oA, t as lA } from "../Ipv4Address-CbH6PWSk.js";
import "vue";
import * as Q from "utif2";
class V {
  /**
  * クッキー情報からCSRF用のtokenを取得します。
  * @returns 値（なければnull)
  **/
  static getCSRFToken() {
    return this.getCookieData("XSRF-TOKEN");
  }
  /**
   * クッキー情報から引数のキー情報を取得します
   * @param tokenName cookieのキー
   * @returns 値（なければnull)
   */
  static getCookieData(A) {
    var e;
    const i = `; ${document.cookie}`.split(`; ${A}=`);
    return i.length === 2 && ((e = i.pop()) == null ? void 0 : e.split(";").shift()) || null;
  }
}
const l = class l {
  /*
   * ローディング開始
   */
  static Start() {
    l.loadingRef != null && (l.loadingcount++, l.loadingRef.startLoading());
  }
  /**
   * 開始されていなければローディング表示を開始します。
   * @return すでにローディング表示されていればfalse、表示されていなければtrueを返します。
   */
  static StartIfNeeded() {
    return l.loadingcount === 0 ? (l.Start(), !0) : !1;
  }
  /*
   * ローディング終了
   */
  static Stop() {
    l.loadingRef != null && l.loadingcount !== 0 && (l.loadingcount--, !(0 < l.loadingcount) && l.loadingRef.stopLoading());
  }
  /**
   * ローディングを強制的に終了します。
   */
  static ForceStop() {
    l.loadingRef != null && (l.loadingcount = 0, l.loadingRef.stopLoading());
  }
  /* 
   * ローディング画面の参照を登録
   * ★App.vue意外から呼び出さないこと★
   */
  static SetLoading(A) {
    l.loadingRef = A;
  }
};
// 参照カウンタ
C(l, "loadingcount", 0), /*
 * ローディング画面のrefs
 */
C(l, "loadingRef");
let v = l;
class J {
  /**
   * モーダル画面を表示します。awaitを組み合わせることでモーダル画面が閉じるまで待つことができます。
   * @param target モーダル画面を表示する要素またはそのID属性
   * @param options モーダル画面のオプション
   * @returns 非同期で結果を受け取るためのPromiseインスタンスを返します。
   *          awaitを併用することでモーダル画面を閉じるまで待つことができます。
   */
  static async doModal(A, t) {
    return new Promise((i) => {
      function e(r) {
        r.target && r.target.removeEventListener(w.Events.hidden, e), i();
      }
      let a = null;
      A instanceof HTMLElement ? a = A : typeof A == "string" && (a = document.getElementById(A)), a && (a.addEventListener(w.Events.hidden, e), new w(a, t).show());
    });
  }
}
class M {
  /**
   * obj1とobj2が一致するかどうかテストします。
   * @param obj1 比較元
   * @param obj2 比較対象
   * @returns obj1とobj2が一致する場合はtrue、異なる場合はfalseを返します。
   */
  static equals(A, t) {
    const i = M.getDiff(A, t);
    return 0 < Object.keys(i).length;
  }
  /**
   * obj1とobj2に指定されたJSONオブジェクトの差分を抽出します。
   * @param obj1 比較元
   * @param obj2 比較対象
   * @returns 差分がある箇所のobj2の値を返します。
   */
  static getDiff(A, t) {
    const i = {};
    for (const e in A)
      if (A.hasOwnProperty(e))
        if (!t.hasOwnProperty(e))
          i[e] = void 0;
        else if (typeof A[e] == "object" && typeof t[e] == "object") {
          const a = M.getDiff(A[e], t[e]);
          0 < Object.keys(a).length && (i[e] = a);
        } else A[e] !== t[e] && (i[e] = t[e]);
    for (const e in t)
      t.hasOwnProperty(e) && !A.hasOwnProperty(e) && (i[e] = t[e]);
    return i;
  }
  /**
   * NULL または undefined か判定します
   * @param obj オブジェクト
   * @returns true: NULL または undefined false:それ以外
   */
  static isNullOrUndefined(A) {
    return A == null;
  }
}
class z {
  /**
   * 以下のルールに従って100分率を算出します。
   * - 0より大きく1未満の場合は有効桁数で切り上げ
   * - 99より大きく100未満の場合は有効桁数で切り捨て
   * - それ以外は有効桁数で切り捨て
   * @param dividend 被除数
   * @param divisor 序数
   * @param precision 有効桁数
   */
  static toPercentage(A, t, i) {
    if (t === 0)
      throw new Error("Divisor cannot be zero.");
    const e = A * 100 / t, a = Math.pow(10, i ?? 0);
    return 0 < e && e < 1 ? Math.ceil(e * a) / a : 99 < e && e < 100 ? Math.floor(e * a) / a : Math.round(e * a) / a;
  }
}
var N = /* @__PURE__ */ ((n) => (n[n.None = 0] = "None", n[n.Png = 1] = "Png", n[n.Jpeg = 2] = "Jpeg", n[n.Bmp = 4] = "Bmp", n[n.Gif = 8] = "Gif", n[n.Jpg = 16] = "Jpg", n[n.Tiff = 32] = "Tiff", n[n.Tif = 64] = "Tif", n))(N || {});
class S {
  /**
   * 画像の拡張子Bitから、MIME文字列を作成します
   */
  static GetMIMEType(A) {
    const t = [];
    return A & 1 && t.push("image/png"), A & 18 && t.push("image/jpeg"), A & 4 && t.push("image/bmp"), A & 8 && t.push("image/gif"), A & 96 && t.push("image/tiff"), t.join(",");
  }
  /**
   * 画像の拡張子Bitから、拡張子一覧を作成します
   */
  static GetExtensions(A) {
    const t = [];
    return A & 16 && t.push(".jpg"), A & 2 && t.push(".jpeg"), A & 1 && t.push(".png"), A & 64 && t.push(".tif"), A & 32 && t.push(".tiff"), A & 4 && t.push(".bmp"), A & 8 && t.push(".gif"), t.join(",");
  }
  /**
   * 画像の拡張子Bitから、有効な拡張子かを判断します
   */
  static ValidateExtensions(A, t) {
    var i = A.lastIndexOf(".");
    if (i === -1)
      return !1;
    let e = A.slice(i).toLowerCase();
    return S.GetExtensions(t).split(",").includes(e);
  }
  /**
   * @brief Canvasに描画された画像に透明度（アルファチャンネル）が含まれるかを判定します。
   * @param canvas 判定対象のHTMLCanvasElement
   * @returns 透明度を持つピクセルが1つでもあればtrue、なければfalseを返します。
   */
  static hasAlphaChannel(A) {
    const t = A.getContext("2d");
    if (!t)
      return !1;
    const e = t.getImageData(0, 0, A.width, A.height).data;
    for (let a = 3; a < e.length; a += 4)
      if (e[a] < 255)
        return !0;
    return !1;
  }
  /**
   * 画像ファイルをリサイズします
   */
  static AsyncImageResizing(A, t, i) {
    return new Promise((e, a) => {
      const r = A.type === "image/tiff" || /\.(tif|tiff)$/i.test(A.name), o = new FileReader();
      o.onload = (g) => {
        if (g.target === null || g.target.result === null) {
          a("Error: e.target.result is null");
          return;
        }
        if (r) {
          try {
            const s = g.target.result, E = Q.decode(s);
            Q.decodeImage(s, E[0]);
            const u = Q.toRGBA8(E[0]), { width: h, height: p } = E[0], d = document.createElement("canvas"), I = d.getContext("2d");
            if (!I) return a("Error: Unable to get canvas context");
            const D = document.createElement("canvas"), L = D.getContext("2d");
            if (!L) return a("Error: Unable to get temp canvas context");
            D.width = h, D.height = p;
            const x = L.createImageData(h, p);
            x.data.set(u), L.putImageData(x, 0, 0);
            let B = 1;
            if (t < h && (B = t / h), i < p) {
              const R = i / p;
              R < B && (B = R);
            }
            if (d.width = h * B, d.height = p * B, I.drawImage(D, 0, 0, d.width, d.height), S.hasAlphaChannel(d))
              e(d.toDataURL("image/png"));
            else {
              const R = d.toDataURL("image/png"), P = d.toDataURL("image/jpeg");
              e(R.length <= P.length ? R : P);
            }
          } catch (s) {
            a(s);
          }
          return;
        }
        const f = new Image();
        f.onload = function() {
          var p;
          const s = document.createElement("canvas"), E = s.getContext("2d");
          if (E === null) {
            a("Error: Unable to get canvas context");
            return;
          }
          if (S.IsAnimatedGif((p = g.target) == null ? void 0 : p.result)) {
            a("Error: Animated GIF is not supported");
            return;
          }
          let u = 1;
          if (t < f.width && (u = t / f.width), i < f.height) {
            const d = i / f.height;
            d < u && (u = d);
          }
          if (s.width = f.width * u, s.height = f.height * u, E.drawImage(f, 0, 0, s.width, s.height), S.hasAlphaChannel(s))
            e(s.toDataURL("image/png"));
          else {
            const d = s.toDataURL("image/png"), I = s.toDataURL("image/jpeg");
            e(d.length <= I.length ? d : I);
          }
        }, f.onerror = (s) => a("Error loading image: " + s), f.src = g.target.result;
      }, o.onerror = (g) => {
        a("Error loading file:" + g);
      }, r ? o.readAsArrayBuffer(A) : o.readAsDataURL(A);
    });
  }
  /**
   * @brief GIFがアニメーションかどうかを判定します。
   * @param dataUrl 判定したいGIF画像のDataURL
   * @returns アニメーションGIFであればtrue、静止画GIFであればfalseを返します。
   */
  static IsAnimatedGif(A) {
    if (!A.startsWith("data:image/gif;base64,"))
      return !1;
    try {
      const t = {
        // ブロックタイプ識別子
        BLOCK_TYPE: {
          IMAGE_SEPARATOR: 44,
          // 各画像フレームの開始
          EXTENSION_BLOCK: 33,
          // 拡張ブロック(コメント, アニメーション制御など)
          GIF_FILE_END_MARKER: 59
          // ファイルの終端マーカー
        },
        // 構造上のオフセットとサイズ
        HEADER_SIZE: 6,
        LOGICAL_SCREEN_DESCRIPTOR_SIZE: 7,
        PACKED_FIELDS_INDEX: 10,
        IMAGE_DESCRIPTOR_SIZE: 9,
        // ビットマスク (特定のビットを調べるための道具)
        MASKS: {
          HAS_COLOR_TABLE: 128,
          // 1000 0000 (最上位ビット)
          COLOR_TABLE_SIZE: 7
          // 0000 0111 (下位3ビット)
        },
        BYTES_PER_COLOR: 3,
        // 1色あたりのバイト数 (R, G, B)
        DATA_SUB_BLOCK_END: 0
        // データサブブロックの終端
      }, i = A.split(",")[1], e = atob(i), a = new Uint8Array(e.length);
      for (let s = 0; s < e.length; s++)
        a[s] = e.charCodeAt(s);
      let r = 0, o = 0;
      o += t.HEADER_SIZE + t.LOGICAL_SCREEN_DESCRIPTOR_SIZE;
      const g = a[t.PACKED_FIELDS_INDEX];
      if ((g & t.MASKS.HAS_COLOR_TABLE) > 0) {
        const s = 1 << (g & t.MASKS.COLOR_TABLE_SIZE) + 1;
        o += t.BYTES_PER_COLOR * s;
      }
      for (; o < a.length; ) {
        const s = a[o];
        if (s === t.BLOCK_TYPE.IMAGE_SEPARATOR) {
          if (r++, r > 1)
            return !0;
          o += 1 + t.IMAGE_DESCRIPTOR_SIZE;
          const E = a[o - 1];
          if ((E & t.MASKS.HAS_COLOR_TABLE) > 0) {
            const h = 1 << (E & t.MASKS.COLOR_TABLE_SIZE) + 1;
            o += t.BYTES_PER_COLOR * h;
          }
          o++;
        } else if (s === t.BLOCK_TYPE.EXTENSION_BLOCK)
          o += 2;
        else if (s === t.BLOCK_TYPE.GIF_FILE_END_MARKER)
          return !1;
        for (; o < a.length && a[o] !== t.DATA_SUB_BLOCK_END; ) {
          const E = a[o];
          o += E + 1;
        }
        o++;
      }
      return r > 1;
    } catch {
      return !1;
    }
  }
}
let U;
const b = new Uint8Array(16);
function y() {
  if (!U && (U = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !U))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return U(b);
}
const c = [];
for (let n = 0; n < 256; ++n)
  c.push((n + 256).toString(16).slice(1));
function K(n, A = 0) {
  return c[n[A + 0]] + c[n[A + 1]] + c[n[A + 2]] + c[n[A + 3]] + "-" + c[n[A + 4]] + c[n[A + 5]] + "-" + c[n[A + 6]] + c[n[A + 7]] + "-" + c[n[A + 8]] + c[n[A + 9]] + "-" + c[n[A + 10]] + c[n[A + 11]] + c[n[A + 12]] + c[n[A + 13]] + c[n[A + 14]] + c[n[A + 15]];
}
const W = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), T = {
  randomUUID: W
};
function F(n, A, t) {
  if (T.randomUUID && !n)
    return T.randomUUID();
  n = n || {};
  const i = n.random || (n.rng || y)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, K(i);
}
const m = class m {
  /**
   * データURIからファイル名を作成
   * @param   [in]    dataURI : データURI
   * @param   [in]    prefix : プレフィックス
   * @return  ファイル名（GUIDで作成）
   */
  static CreateFileName(A, t = void 0) {
    let i = "";
    return A.startsWith("data:image/png") ? i = "png" : A.startsWith("data:image/jpeg") ? i = "jpg" : i = "", t == null ? `${F()}.${i}` : `${t}_${F()}.${i}`;
  }
  /**
   * データURI⇒FileContentDataURI
   * @param   [in]    dataURI : データURI
   * @return  FileContentDataURI（※ファイル名はGUIDで作成）
   */
  static DataURIToFileContent(A) {
    return {
      dataURI: A,
      fileName: m.CreateFileName(A),
      fileSize: m.DataURItoFileSize(A)
    };
  }
  /*
  * HTML内のデータURIをファイル名に変換
  * @param   [in]    srcHtml : HTMLテキスト(<img>のsrcはデータURI)
  * @return  [in]    callbackSetFileList : ファイル情報をセットするコールバック関数
  * @return  fileList: 変換したファイル情報
  */
  static DataURIsToFileNames_InHTML(A, t) {
    let i = A;
    if (i.indexOf("img", 0) !== void 0) {
      const e = /<img[^>]*?src="([^"]*?)"[^>]*?>/gi;
      let a, r = i;
      for (; (a = e.exec(i)) !== null; ) {
        const o = a[1], g = m.DataURIToFileContent(o);
        t(g.dataURI, g.fileName, g.fileSize), r = r.replace(g.dataURI, g.fileName);
      }
      i = r;
    }
    return i;
  }
  /*
  * HTML内のファイル名をデータURIに変換
  * @param   [in]    srcHtml : HTMLテキスト(<img>のsrcはファイル名)
  * @param   [in]    callbackGetFileInfo : ファイル情報を取得するコールバック関数（dataURI: データURI, fileName: ファイル名）
  * @return  srcHtml内のファイル名をデータURIに置き換えた文字列
  */
  static FileNamesToDataURIs_InHTML(A, t, i) {
    let e = A;
    for (let a = 0; a < t; a++) {
      const r = i(a);
      r.fileName !== void 0 && r.fileName !== null && r.dataURI !== void 0 && r.dataURI !== null && (e = e.replace(r.fileName, r.dataURI));
    }
    return e;
  }
  /*
  * HTML内の<img>タグのsrcを列挙します
  * @param   [in]    srcHtml : HTMLテキスト
  * @return  srcHtml内のsrc一覧
  */
  static EnumImgSrc_inHtml(A) {
    const t = new Array();
    if (A.indexOf("img", 0) !== void 0) {
      const i = /<img[^>]*?src="([^"]*?)"[^>]*?>/gi;
      let e;
      for (; (e = i.exec(A)) !== null; ) {
        const a = e[1];
        t.push(a);
      }
    }
    return t;
  }
  /*
  * データURIの文字列から、バイナリ時のサイズを計算します
  * @param   [in]    dataURI : データURI
  * @return  バイナリ時のファイルサイズ
  */
  static DataURItoFileSize(A) {
    const t = A.replace(/^data:.*;base64,/, ""), i = t.length;
    return Math.ceil(i * 3 / 4) - (t.endsWith("==") ? 2 : t.endsWith("=") ? 1 : 0);
  }
  /*
   * データURIが取得失敗の画像かどうか
   * @param   [in]    dataURI : データURI
   */
  static IsPicFailedImage(A) {
    return A.toUpperCase() === m.PIC_FAILED_IMAGE.toUpperCase();
  }
};
/**
 * 取得失敗の画像
 */
C(m, "PIC_FAILED_IMAGE", "data:image/jpeg;base64,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");
let G = m;
class q {
  /**
   * 文字列がMACアドレスの形式（コロンまたはハイフン区切り）であるかを判定します。
   * @param text - 検証する文字列
   * @returns MACアドレス形式の場合はtrue、それ以外はfalseを返します。
   */
  static isMacAddress(A) {
    return A ? /^([0-9A-Fa-f]{2}[-]){5}[0-9A-Fa-f]{2}$/.test(A) : !1;
  }
  /**
   * 文字列がIPv4であるかを判定します。
   * @param text - 検証する文字列
   * @returns CIDRの場合はtrue、それ以外はfalseを返します。
   */
  static isIPv4(A) {
    return !A || !/^([0-9]{1,3}\.){3}[0-9]{1,3}$/.test(A) ? !1 : A.split(".").every((e) => {
      if (1 < e.length && e.startsWith("0"))
        return !1;
      const a = parseInt(e, 10);
      return 0 <= a && a <= 255;
    });
  }
  /**
   * 文字列がClassless Inter-Domain Routing（CIDR）であるかを判定します。
   * @note CIDRは"192.168.0.0/16"のように「<先頭アドレス>/<ネットワーク部のビット数>」という形式を指します。
   * @param text - 検証する文字列
   * @returns CIDRの場合はtrue、それ以外はfalseを返します。
   */
  static isCIDR(A) {
    return !A || !/^([0-9]{1,3}\.){3}[0-9]{1,3}\/([0-9]|[1-2][0-9]|3[0-2])$/.test(A) ? !1 : A.split("/")[0].split(".").every((a) => {
      if (1 < a.length && a.startsWith("0"))
        return !1;
      const r = parseInt(a, 10);
      return 0 <= r && r <= 255;
    });
  }
}
export {
  $ as BootstrapUtil,
  iA as ConvStorageUtil,
  V as CookieUtil,
  G as DataURIUtil,
  q as FormatValidator,
  AA as HttpRequestUtil,
  N as ImageTypeBit,
  S as ImageUtil,
  sA as Ipv4Address,
  v as LoadingUtil,
  z as MathUtil,
  J as ModalUtil,
  tA as NaturalCompare,
  M as ObjectUtil,
  rA as RoundType,
  eA as StringHelper,
  nA as UUIDUtil,
  oA as toBitPositions,
  lA as toStringArray
};
